import DOMPurify from 'dompurify'

/**
 * 이메일 답변 HTML 을 화면에 그리기 전에 정화한다 — 고객 My Messages · 백오피스 타임라인 공용.
 * 허용 = TipTap 에디터(inquiryReplyEditor)가 만드는 태그뿐. 스크립트·이벤트 속성·iframe 은 DOMPurify 가 뗀다.
 * 링크는 새 탭으로, 이미지는 우리 S3(judahs-public) 주소만 남긴다.
 */
const ALLOWED_TAGS = [
	'p',
	'br',
	'strong',
	'b',
	'em',
	'i',
	'u',
	's',
	'strike',
	'mark',
	'span',
	'h1',
	'h2',
	'h3',
	'ul',
	'ol',
	'li',
	'blockquote',
	'pre',
	'code',
	'hr',
	'a',
	'img',
]
const ALLOWED_ATTR = ['href', 'src', 'alt', 'style', 'target', 'rel']
const IMAGE_HOST = /^https:\/\/judahs-public\.s3[.-]/

export const sanitizeReplyHtml = (html: string): string => {
	const clean = DOMPurify.sanitize(html, {
		ALLOWED_TAGS: ALLOWED_TAGS,
		ALLOWED_ATTR: ALLOWED_ATTR,
		RETURN_DOM: true,
	}) as HTMLElement

	clean.querySelectorAll('img').forEach(anImage => {
		if (!IMAGE_HOST.test(anImage.getAttribute('src') ?? '')) anImage.remove()
	})
	clean.querySelectorAll('a').forEach(aLink => {
		aLink.setAttribute('target', '_blank')
		aLink.setAttribute('rel', 'noopener noreferrer')
	})

	return clean.innerHTML
}

/** 서버가 준 base64 를 파일로 내려받게 한다 */
export const downloadBase64File = (file: {
	fileName: string
	contentType: string
	base64: string
}): void => {
	const bytes = Uint8Array.from(atob(file.base64), aChar => aChar.charCodeAt(0))
	const url = URL.createObjectURL(new Blob([bytes], { type: file.contentType }))
	const link = document.createElement('a')
	link.href = url
	link.download = file.fileName
	document.body.appendChild(link)
	link.click()
	link.remove()
	setTimeout(() => URL.revokeObjectURL(url), 1000)
}

/** 1234 → '1.2 KB' */
export const formatFileSize = (bytes: number): string => {
	if (bytes < 1024) return `${bytes} B`
	if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
	return `${(bytes / 1024 / 1024).toFixed(1)} MB`
}
